/**
 * Utilitaires de formatage partagés
 */

/**
 * Formate un symptôme brut : remplace les underscores par des espaces et capitalise le premier mot.
 * "perte_puissance" → "Perte de puissance"
 */
export function formatSymptom(raw: string): string {
  if (!raw) return '';
  const text = raw.replace(/_/g, ' ').trim();
  return text.charAt(0).toUpperCase() + text.slice(1);
}

/**
 * Formate un kilométrage avec séparateur de milliers : 113114 → "113 114 km"
 */
export function formatMileage(km: number | string | null | undefined): string {
  if (km === null || km === undefined || km === '') return '—';
  const num = typeof km === 'string' ? parseInt(km, 10) : km;
  if (isNaN(num)) return '—';
  return `${new Intl.NumberFormat('fr-FR').format(num)} km`;
}

/**
 * Formate un montant en euros : 2199 → "2 199,00 €"
 */
export function formatPrice(price: number | null | undefined): string {
  if (price === null || price === undefined) return '—';
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  }).format(price);
}

/**
 * Raccourcit un identifiant long en gardant les N derniers caractères.
 * "CTR-2026-ABCDEF1234" → "…1234"
 */
export function shortId(id: string | null | undefined, length = 4): string {
  if (!id) return '—';
  if (id.length <= length) return id;
  return `…${id.slice(-length)}`;
}

export { formatPhoneInternational as formatPhone } from './phone';

/**
 * Construit une URL Google Maps à partir d'une adresse.
 */
export function googleMapsUrl(address: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}
